import NotFoundPage from '../components/NotFoundPage';
import { useOwner } from '@watershed/shared-frontend/hooks/useOwner';
import { Teams } from '@watershed/constants/teams';

export default function Watershed404() {
  useOwner(Teams.EnterpriseFoundations);
  return <NotFoundPage />;
}
